import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Chat } from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';

import { Theme } from '@mui/material';
import Async from 'components/Async';
import store from 'store';
import addOpacityToRGB from '@common/helpers/addOpacityToRGB';

import CommonChat from '@common/modules/Chat';

import './index.css';
import { CommonChatWrapper } from './styled';

function ClientChat() {
	const { t } = useTranslation();
	useEffect(() => {
		if (store.chat.loading) {
			return;
		}

		store.chat.client.queryChannels(
			{},
			{},
			{
				watch: true,

				state: true,
			},
		);
	}, [store.chat.loading]);

	return (
		<CommonChatWrapper
			sx={(theme: Theme) => ({
				'--primary-main': theme.palette.primary.main,
				'--primary-light':
					addOpacityToRGB(theme.palette.primary.light, 0.5) || theme.palette.primary.light,
				'--text-main': theme.palette.text.primary,
				'--text-secondary': theme.palette.text.secondary,
				'--text-icon': `${theme.palette.text.secondary}80`,
			})}
		>
			<Async loading={store.chat.loading}>
				<Chat client={store.chat.client}>
					<CommonChat store={store} showChannelSearch={false} t={t} />
				</Chat>
			</Async>
		</CommonChatWrapper>
	);
}

export default observer(ClientChat);
